var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-1',{staticClass:"widget-view",style:({})})
}
var staticRenderFns = []

export { render, staticRenderFns }